/* Scoped custom-size order properties for the lace-up boot collection. */
(()=>{
 'use strict';
 const saved=new Map(),standard=new Map();
 const formFor=block=>document.getElementById(block.dataset.customFormId)||block.closest('form');
 const values=root=>JSON.parse(root.dataset.customValues).map(v=>v.trim());
 const radios=root=>[...root.querySelectorAll('input[type="radio"]')];
 function enhance(root){
  if(root.closest('variant-selects')?.style.display==='none')return;
  const custom=values(root),inputs=radios(root),selected=inputs.find(i=>i.checked);if(!selected)return;
  const key=selected.form?.id+'|'+selected.name;if(!custom.includes(selected.value))standard.set(key,selected.value);
  const active=custom.includes(selected.value);root.dataset.mode=active?'custom':'size';root.classList.add('is-enhanced');
  inputs.forEach(input=>{if(!custom.includes(input.value))return;input.dataset.sdNativeCustom='';root.querySelector(`label[for="${CSS.escape(input.id)}"]`)?.setAttribute('data-sd-native-custom','');});
  root.querySelectorAll('[role="tab"]').forEach(tab=>{const on=(tab.dataset.sdSizeMode==='custom')===active;tab.setAttribute('aria-selected',String(on));tab.tabIndex=on?0:-1;});
  root.querySelector('.sd-size-standard').setAttribute('aria-hidden',String(active));root.querySelector('.sd-size-custom').setAttribute('aria-hidden',String(!active));
 }
 function choose(tab){
  const root=tab.closest('[data-sd-size-tabs]'),custom=values(root),inputs=radios(root),selected=inputs.find(i=>i.checked);if(!selected)return;
  const note=root.querySelector('[data-sd-custom-size] textarea');
  if(note&&!note.disabled){const form=formFor(note.closest('[data-sd-custom-size]'));if(form){saved.set(form.id,note.value);form.dataset.sdCustomNote=note.value;}}
  const key=selected.form?.id+'|'+selected.name;
  const input=tab.dataset.sdSizeMode==='custom'?inputs.find(i=>custom.includes(i.value)):inputs.find(i=>i.value===standard.get(key)&&!custom.includes(i.value))||inputs.find(i=>!custom.includes(i.value)&&!i.classList.contains('disabled'))||inputs.find(i=>!custom.includes(i.value));
  if(input&&!input.checked)input.click();refresh();
 }
 document.addEventListener('click',event=>{const tab=event.target.closest('[data-sd-size-mode]');if(tab){event.preventDefault();choose(tab);}});
 document.addEventListener('keydown',event=>{const tab=event.target.closest('[data-sd-size-mode]');if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const tabs=[...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];const next=event.key==='Home'?tabs[0]:event.key==='End'?tabs[1]:tabs[tab===tabs[0]?1:0];next.focus();choose(next);});
 function sync(block){
  if(block.closest('variant-selects')?.style.display==='none')return false;
  const form=formFor(block),input=block.querySelector('textarea');
  if(!form||!input)return false;
  const selected=form.querySelector('[name="id"]')?.value||'';
  const root=block.closest('[data-sd-size-tabs]');
  const active=root?root.dataset.mode==='custom':selected!==''&&block.dataset.customVariantIds.split(',').filter(Boolean).includes(String(selected));
  const formKey=form.getAttribute('id');
  if(!input.value&&form.dataset.sdCustomNote!==undefined)input.value=form.dataset.sdCustomNote;
  else if(!input.value&&saved.has(formKey))input.value=saved.get(formKey);
  block.hidden=!active;input.disabled=!active;input.required=active&&block.dataset.customRequired!=='false';
  form.classList.toggle('sd-custom-size-active',active);
  if(!active)input.setCustomValidity('');
  return active;
 }
 function refresh(){document.querySelectorAll('[data-sd-size-tabs]').forEach(enhance);document.querySelectorAll('[data-sd-custom-size]').forEach(sync);}
 document.addEventListener('change',()=>{refresh();requestAnimationFrame(refresh);});
 // Notes are form-associated but sit in the picker panel; they are not variant changes.
 document.addEventListener('change',event=>{if(event.target.matches('[data-sd-custom-size] textarea')){const input=event.target,form=formFor(input.closest('[data-sd-custom-size]'));if(form){saved.set(form.id,input.value);form.dataset.sdCustomNote=input.value;}event.stopPropagation();}},true);
 document.addEventListener('input',event=>{
  const input=event.target;
  if(!input.matches('[data-sd-custom-size] textarea'))return;
  const form=formFor(input.closest('[data-sd-custom-size]'));if(form){saved.set(form.id,input.value);form.dataset.sdCustomNote=input.value;}input.setCustomValidity('');
 },true);
 // Product forms use novalidate; validate before any AJAX add-to-cart handler.
 document.addEventListener('submit',event=>{
  const form=event.target,block=[...document.querySelectorAll('[data-sd-custom-size]')].find(b=>formFor(b)===form);
  if(!block||!sync(block))return;
  const input=block.querySelector('textarea');
  input.value=input.value.trim();
  if(input.required&&!input.value){
   event.preventDefault();event.stopImmediatePropagation();
   input.setCustomValidity(block.dataset.customError||'ご希望のカスタムサイズをご入力ください。');
   input.focus();input.reportValidity();
  }else input.setCustomValidity('');
 },true);
 let pending=false;
 new MutationObserver(records=>{
  if(pending||!records.some(r=>r.type==='attributes'||r.addedNodes.length))return;
  pending=true;requestAnimationFrame(()=>{pending=false;refresh();});
 }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
 document.addEventListener('shopify:section:load',refresh);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
